import { templateApi } from "@/core/data/api";

export default async (values) => {
  return await templateApi.updateTemplate(values.id, values);
};
